import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { STATUS_OBJECT } from 'src/app/dummy/status';
import { Router, ActivatedRoute } from '@angular/router';
import { PrintService } from 'src/app/services/print.service';
import { BOOK_STORE_TABS } from 'src/app/dummy/tab';
import { RegisterTesting } from 'src/app/stores/enrollment/registerTesting.store';
import { AuthStore } from 'src/app/stores/auth/auth.store';

@Component({
  selector: 'app-admission',
  templateUrl: './admission.component.html',
  styleUrls: ['./admission.component.scss']
})
export class AdmissionComponent implements OnInit {
  @ViewChild('PRINT_TABLE', {static:false}) PRINT_TABLE: ElementRef;
  tabs = BOOK_STORE_TABS.STUDENT_ADMISSION;
  DISPLAY_STATUS_KEY: any;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    public store: RegisterTesting,
    public ps: PrintService,
    public auth: AuthStore,
  ) { }

  async ngOnInit() {
    this.route.params.subscribe(async (param) => {
      this.DISPLAY_STATUS_KEY = STATUS_OBJECT[param['id']];
      const { selectedCompanyKey } = this.auth;
      this.store.fetchAdmission(selectedCompanyKey)
    })
  }

  create() {
    this.router.navigate([`/enrollment/register-test/form/draft`])
  }

  edit(item: any) {
    this.router.navigate([`/enrollment/register-test/form/${item.key}`])
  }

  onSetResult(item: any) {

  }

}
